app.controller("StudentPaymentInstructionsController", [
    "$scope", "$uibModalInstance",
    function ($scope, $uibModalInstance) {

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
